import { generateApiPath } from '@scouts/helpers'

import { Agreement, DraftAgreement } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'

interface UserIdParam {
    userId?: number
}

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAgreements: builder.query<Agreement[], UserIdParam>({
            query: ({ userId }) => ({
                method: 'GET',
                url: generateApiPath(ENDPOINTS.AGREEMENTS.GET, { userId }),
            }),
        }),
        getPendingAgreement: builder.query<DraftAgreement, UserIdParam & { agreementType: Agreement['type'] }>({
            query: ({ userId, agreementType }) => ({
                method: 'GET',
                url: generateApiPath(
                    ENDPOINTS.PENDING_AGREEMENT.GET,
                    { userId },
                    { queryParameters: { type: agreementType } }
                ),
            }),
        }),
    }),
})

export const { useGetAgreementsQuery, useGetPendingAgreementQuery } = extendedApi
